import axios from "axios";
import { AuthService } from "./AuthService";

const BASE_URL = process.env.REACT_APP_API_URL;
const METHOD = {
    POST: "POST",
    GET: "GET",
    PUT: "PUT",
    DELETE: "DELETE"
}

const setHeader = (auth) => {
    const headers = {
        "Content-Type": "application/json"
    }

    if (auth) {
        headers["ComCd"] = AuthService.getComCd();
        headers["Authorization"] = `Bearer ${AuthService.getToken()}`;
    }

    return headers;
}

const handleError = (error) => {
    const message = {};
    if(error.response){
        message['errorCode'] = error.response.status;
        message['message'] = error.response.data?.message ?? error.message;
    }else{
        message['error'] = error.message;
    }
    
    return message;
};

const get = (url) => {
    return request(url, METHOD.GET);
}

const put = (url, body) => {
    return request(url, METHOD.PUT, body);
}

const del = (url) => {
    return request(url, METHOD.DELETE);
}

const post = (url, body) => {
    if (url === "auth/login") {
        return loginRequest(url, body);
    }
    return request(url, METHOD.POST, body);
}

const loginRequest = async (url, body) => {
    const apiUrl = BASE_URL + "/" + url;
    try {
        const response = await axios({
            url: apiUrl,
            method: METHOD.POST,
            headers: setHeader(false),
            data: body,
        });
        return { success: true, data: response.data };
    } catch (error) {
        return { success: false, error : handleError(error) }; 
    }
}

const request = async (url, method, body = {}) => {
    const apiUrl = BASE_URL + "/" + url;
    try {
        const response = await axios({
            url: apiUrl,
            method: method,
            headers: setHeader(true),
            data: body,
        });
        return { success: true, data: response.data };
    } catch (error) {
        return { success: false, error : handleError(error) }; 
    }
}

export const ApiService = {
    post, get, put, del, setHeader
}